// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__18pip"};